/**
 * @generated SignedSource<<fc3304e691871b808aacde54ee4f85ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef$data = {
  readonly isAiEnabledInAdminHub?: boolean | null | undefined;
  readonly isVirtualAgentAvailable: boolean | null | undefined;
  readonly " $fragmentType": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef";
};
export type nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef$key = {
  readonly " $data"?: nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "nestedNav_navigationAppsSidebarServicedesk_VirtualAgentNestedNav_virtualAgentFeaturesRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isVirtualAgentAvailable"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAiEnabledInAdminHub"
        }
      ]
    }
  ],
  "type": "VirtualAgentFeatures"
};

(node as any).hash = "ee71e92c7b841f7b1594c4636880f22d";

export default node;
